export const PROMOTED_BREAKS = [
    {
        id: '1',
        title: 'Christmas and New Year',
        subTitle: 'Festive breaks available at Cala Gran, Kent Coast, Primrose Valley, Rockley Park and Seashore',
        shortTitle: 'Festive',
        events: [
            {
                id: '8',
                title: 'Christmas break',
                startDate: '2024-12-23',
                endDate: '2024-12-27',
                duration: ['4'],
                parkCodes: ['CG', 'AH', 'PV', 'RP', 'SA'],
                content: 'Mon 23rd Dec 2024 - Fri 27th Dec 2024',
            },
            {
                id: '9',
                title: 'New Year Break',
                startDate: '2024-12-30',
                endDate: '2025-01-03',
                duration: ['4'],
                parkCodes: ['CG', 'AH', 'PV', 'RP', 'SA'],
                content: 'Mon 30th Dec 2024 - Fri 3rd Jan 2025',
            },
            {
                id: '10',
                title: 'Festive breaks',
                startDate: '2024-12-01',
                endDate: '2024-12-29',
                duration: ['3', '4', '5', '6', '7'],
                parkCodes: ['CG', 'AH', 'PV', 'RP', 'SA'],
                content: 'Various dates through December 2024',
            },
        ],
    },
    {
        id: 'search.campaign.euro',
        title: 'Euros',
        subTitle: 'Euros',
        shortTitle: 'Euros',
        events: [
            {
                id: '80',
                title: 'Euros break',
                startDate: '2024-12-23',
                endDate: '2024-12-27',
                duration: ['4'],
                parkCodes: ['CG', 'AH', 'PV', 'RP', 'SA'],
                content: 'Mon 23rd Dec 2024 - Fri 27th Dec 2024',
            },
            {
                id: '90',
                title: 'Euros Year Break',
                startDate: '2024-12-30',
                endDate: '2025-01-03',
                duration: ['4'],
                parkCodes: ['CG', 'AH', 'PV', 'RP', 'SA'],
                content: 'Mon 30th Dec 2024 - Fri 3rd Jan 2025',
            },
            {
                id: '100',
                title: 'Euros Festive breaks',
                startDate: '2024-12-01',
                endDate: '2024-12-29',
                duration: ['3', '4', '5', '6', '7'],
                parkCodes: ['CG', 'AH', 'PV', 'RP', 'SA'],
                content: 'Various dates through December 2024',
            },
        ],
    },
];
export const TEST_PROMOTED_BREAKS = [
    {
        id: '1',
        title: 'Christmas and New Year',
        subTitle: 'Festive breaks available at Cala Gran, Kent Coast, Primrose Valley, Rockley Park and Seashore',
        shortTitle: 'Festive',
        events: [
            {
                id: '8',
                title: 'Christmas break',
                startDate: '2024-12-23',
                endDate: '2024-12-27',
                duration: ['4'],
                parkCodes: ['CG', 'AH', 'PV', 'RP', 'SA'],
                content: 'Mon 23rd - Fri 27th Dec 2024',
            },
            {
                id: '9',
                title: 'New Year Break',
                startDate: '2024-12-30',
                endDate: '2025-01-03',
                duration: ['4'],
                parkCodes: ['CG', 'AH', 'PV', 'RP', 'SA'],
                content: 'Mon 30th Dec 2023 - Thu 2nd Jan 2024',
            },
            {
                id: '10',
                title: 'Festive breaks',
                startDate: '2024-12-01',
                endDate: '2024-12-29',
                duration: ['3', '4', '5', '6', '7'],
                parkCodes: ['CG', 'AH', 'PV', 'RP', 'SA'],
                content: 'Various dates through December 2024',
            },
        ],
    },
];
export const INVENTORY_DATA_URL = '/search-results/v2/api/availability-leading-prices';
export const PROMOTIONS_DATA_URL = '/search-results/v2/api/promotion-campaigns';
